"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _BuildConstants = require("../../../../utils/BuildConstants");

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _RegisterInstance = _interopRequireDefault(require("../../RegisterInstance"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

/**
 * Created by falknisius on 31.05.17.
 */
var GetFullLikes = /*#__PURE__*/function () {
  function GetFullLikes() {
    (0, _classCallCheck2["default"])(this, GetFullLikes);
  }

  (0, _createClass2["default"])(GetFullLikes, null, [{
    key: "askForLikes",
    value: function () {
      var _askForLikes = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var url, data, result, token;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('askForLikes1');

                if (_config["default"]) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return (0, _TimeoutHelper.timeout)(100);

              case 4:
                return _context.abrupt("return", GetFullLikes.askForLikes());

              case 5:
                console.log('askForLikes2');

                if (_config["default"].likeRetrieveUrl) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", _promise["default"].reject(new Error('no like retrieve url found')));

              case 8:
                url = _BuildConstants.LEDGER_HOST + '/' + _config["default"].likeRetrieveUrl;
                data = {};
                console.log('askForLikes3', url);
                _context.prev = 11;

                if (!_config["default"].backendUseBearerAuth) {
                  _context.next = 21;
                  break;
                }

                _context.next = 15;
                return _RegisterInstance["default"].getAccessToken('logAggregate:read');

              case 15:
                token = _context.sent;
                _context.next = 18;
                return (0, _HttpRequest.httpGet)(url, data, null, null, 2, 'Bearer ' + token);

              case 18:
                result = _context.sent;
                _context.next = 24;
                break;

              case 21:
                _context.next = 23;
                return (0, _HttpRequest.httpGet)(url, data, null, null, 2, null);

              case 23:
                result = _context.sent;

              case 24:
                console.log('askForLikes3', result);

                if (!(result.status === 200)) {
                  _context.next = 29;
                  break;
                }

                return _context.abrupt("return", _promise["default"].resolve({
                  name: 'updateLikes',
                  data: result.data
                }));

              case 29:
                return _context.abrupt("return", _promise["default"].reject(new Error('ERROR_HTTP_COMMUNICATION')));

              case 30:
                _context.next = 36;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](11);
                console.error(_context.t0);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[11, 32]]);
      }));

      function askForLikes() {
        return _askForLikes.apply(this, arguments);
      }

      return askForLikes;
    }()
  }]);
  return GetFullLikes;
}();

var _default = GetFullLikes;
exports["default"] = _default;